// 获取港口及泊位数
export const PORT_BERTH_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9]
export const ADDRESS_COMMISSION_OPTIONS = [
  {
    value: 'Nil',
    label: 'Nil'
  },
  {
    value: 1,
    label: '1 %'
  },
  {
    value: 1.25,
    label: '1.25 %'
  },
  {
    value: 2,
    label: '2 %'
  },
  {
    value: 2.5,
    label: '2.5 %'
  },
  {
    value: 3.75,
    label: '3.75 %'
  },
  {
    value: 5,
    label: '5 %'
  }
]

// 'Nil', '1 %', '1.25 %', '2 %', '2.5 %', '3 %', '3.75 %', '5 %'
export const CURRENCY = ['EUR', 'CNY', 'JPY', 'SGD']
export const FREIGHT_CONSTRAINT = [
  {
    value: 'FIO',
    label: 'FIO (Free In Free Out)'
  },
  {
    value: 'LIFO',
    label: 'LIFO (Liner In Free Out)'
  },
  {
    value: 'FILO',
    label: 'FILO (Free In Liner Out)'
  },
  {
    value: 'FLT',
    label: 'FLT (Full Liner Terms)'
  }
]

export const L_D_FREIGHT_CONSTRAINT = [
  {
    value: 'SHEX UU',
    label: 'SHEX UU(Sunday holidays excluded unless used)'
  },
  {
    value: 'SHEX EIU',
    label: 'SHEX EIU(Sunday holidays excluded even if used)'
  },
  {
    value: 'SHINC',
    label: 'SHINC(Sunday holidays included)'
  },
  {
    value: 'FHEX UU',
    label: 'FHEX UU(Friday holidas excluded unless used'
  },
  {
    value: 'FHEX EIU',
    label: 'FHEX EIU(Friday holidays excluded even if used)'
  },
  {
    value: 'FHINC',
    label: 'FHINC(Friday holidays included)'
  }
]
export const SAFE_PORTS = [
  {
    value: '1SP',
    label: '1SP[Safe Port(s)] Out of'
  },
  {
    value: 'TM',
    label: 'To make(TM)'
  },
  {
    value: 'Passing',
    label: 'Passing'
  },
  {
    value: 'APS',
    label: 'APS'
  }
]
export const DISTANCE_DETAIL = [
  {
    distance: '500 NM',
    shipSizeCode: 'M',
    shipSizeRange: '[1-3,000) MT',
    shipType: 'Mini Bulker'
  }, {
    distance: '750 NM',
    shipSizeCode: 'T',
    shipSizeRange: '[3,000-10,000) MT',
    shipType: 'Thousand Tonnage'
  }, {
    distance: '1000 NM',
    shipSizeCode: 'B',
    shipSizeRange: '[10,000-20,000) MT',
    shipType: 'Baby Handy Size'
  }, {
    distance: '1250 NM',
    shipSizeCode: 'SH',
    shipSizeRange: '[20,000-28,000) MT',
    shipType: 'Small Handy Size'
  }, {
    distance: '1500 NM',
    shipSizeCode: 'H',
    shipSizeRange: '[28,000-40,000) MT',
    shipType: 'Handysize',
    shipType2: 'Seawaymax'
  }, {
    distance: '2000 NM',
    shipSizeCode: 'HM',
    shipSizeRange: '[40,000-50,000) MT',
    shipType: 'Handymax'
  }, {
    distance: '2500 NM',
    shipSizeCode: 'S',
    shipSizeRange: '[50,000-60,000) MT',
    shipType: 'Supramax'
  }, {
    distance: '3500 NM',
    shipSizeCode: 'U',
    shipSizeRange: '[60,000-70,000) MT',
    shipType: 'Ultramax'
  }, {
    distance: '5000 NM',
    shipSizeCode: 'P',
    shipSizeRange: '[70,000-80,000) MT',
    shipType: 'Panamax'
  }, {
    distance: '7000 NM',
    shipSizeCode: 'K',
    shipSizeRange: '[80,000-100,000) MT',
    shipType: 'Kamsarmax',
    shipType2: 'Post-Panamax',
    shipType3: 'Over-Panamax , LME (Large Modern Ecotype)'
  }, {
    distance: '10000 NM',
    shipSizeCode: 'C',
    shipSizeRange: '[100,000-200,000) MT',
    shipType: 'Capesize',
    shipType2: 'Neopanamax/New Panamax-120000dwt',
    shipType3: 'Suezmax 160,000dwt........'
  }, {
    distance: '15000 NM',
    shipSizeCode: 'V',
    shipSizeRange: '[200,000-300,000) MT',
    shipType: 'VLOC',
    shipType2: 'VLBC',
    shipType3: 'Setouchmax 203,000dwt'
  }, {
    distance: '15000 NM',
    shipSizeCode: 'CM',
    shipSizeRange: '[300,000-500,000) MT',
    shipType: 'Chinamax',
    shipType2: 'Valemax',
    shipType3: 'Malaccamax 300,000dwt'
  }
]
